import "../index.css";

export const Privacy = (props) => {
  //const { onSubmit } = props;

  return (
    <div className="p-12 terms ">
      <p className="text-xl font-extrabold ">Privacy Policy</p>
      <p>
        Last updated: June 27, 2023<br></br>
        This Privacy Policy (“Policy”) informs you of wavWRLD’s (“wavWRLD”,
        “we”, “us”, “our”) policies regarding the collection, use and disclosure
        of Personal information (defined below) when you use our websites,
        mobile applications, social media sites and handles, and receive emails
        we send (collectively our “Services”). By using the Service, you
        acknowledge that the collection and use of information is subject to
        this Policy.
      </p>
      <p className="termsUpper mt-3">
        <b> Information Collection</b>
      </p>
      <p>
        We collect both personal and anonymous information through our Services.
        Personal information includes information that can allow someone to
        identify you individually, including, for example, your name, email
        address, as well as any other non-public information about you that is
        associated with or linked to any of this identifiable information.
        Anonymous information include data that is aggregated and/or
        de-identified data, that is not associated with or linked to your
        personal information and typically cannot by itself identify individual
        persons. We collect personal information and anonymous information as
        described below. You may not always need to provide us with personal
        information in order to browse our Service. However, if you do not
        provide the personal information that is necessary, we may not be able
        to respond to your query or provide certain Services to you.
      </p>
      <p>
        <b>Types of Information Collected</b>
      </p>
      <p>
        Depending on how you interact with the Services, we may collect the
        following personal information about or from you: Personal information
        and contact information, such as your name, e-mail address, username,
        wallet address, wallet type, profile picture and any other information
        you submit through the sign-up form when you register for an account.
        Communications between you and us. When you communicate with us, such as
        through e-mail or text message, we may collect and save a record of your
        communication and any Personal information provided during the
        communication. Settings and preferences that you may set through our
        Services. Usage data and automatically collected technical information
        such as status during the WavGAME, traffic data, location data, logs,
        and other communication data and the resources that you access and use
        on the Services. Information about your computer and internet
        connection, including, but not limited to, the type of device you use,
        the IP address of your device, your operating system, the type of
        Internet browser you use, unique device identifiers and other diagnostic
        data. Other data that we may collect from you where you voluntarily
        provide it or where we provide notice that information is being
        collected.
      </p>
      <p className="termsUpper mt-3">
        <b>Sources of Information</b>
      </p>
      <p>
        We collect Information from various sources including data directly from
        you, from third parties, from public sources, and from automated
        systems. Direct interactions. You may give us your personal information
        by filling in forms or by corresponding with us by post, email or
        otherwise. This includes data you provide when you: sign up for our
        Services; signing in to your wallet to access the Services; engage
        customer support; give us feedback or contact us. Information We Collect
        from Third Parties. We may collect personal information about you from
        third-party sources. We may also collected and also anonymous or
        aggregated information from third-party sources (which may be combined
        with other personal information we have collected about you), such as:
        Blockchain: we collect certain personal information about you that is
        publicly available on a decentralized public ledger, including your
        wallet types, amounts of digital assets you possess and account
        balances. Publically available sources: We may collect information from
        publicly available sources such as public databases. Third party
        partners: We may also receive information from business partners,
        enforcement partners, and other third parties we work with, including
        wallet providers. Automated technologies or interactions. As you
        interact with our Services, we may automatically collect technical data
        about your equipment, browsing actions and patterns, and frequency of
        use. We collect this information by using cookies and other similar
        technologies. Please see below for further details.
      </p>
      <p className="termsUpper mt-3">
        <b>Retention of Personal Information</b>
      </p>
      <p>
        Except to the extent prohibited by law or as otherwise stated in this
        Policy or at the time of collection, and subject to this Policy, we will
        retain and use your Personal information for as long as it is needed for
        fulfil the purposes related to your use of the Services and the purposes
        described in this Policy. These purposes include providing you with any
        of our Services, communications, information you have requested, or
        access to the Services, to document our business relationship with you,
        and as necessary to comply with our legal obligations, prevent fraud and
        abuse, resolve disputes, and enforce our agreements. We may continue to
        retain your personal information even after you deactivate your account
        and/or cease to use the Services for the reasons described in this
        Policy. Please note that the nature of blockchain services is that
        certain data cannot be deleted or erased.
      </p>
      <p className="termsUpper mt-3">
        <b>Use of Information</b>
      </p>
      <p>
        We use the information that we collect for various purposes, including:
        <br></br>•To provide you with our Service, including helping you
        participate in the wavGAME, keeping a record of your NFTs and
        activities, and providing you notifications you have requested.
        <br></br>•To allow you to purchase NFTs;
        <br></br>•To set up and maintain your account.
        <br></br>•To respond to your inquires, requests, and questions.
        <br></br>•To notify you about changes to our Service, news about our
        Services and new features or offerings, and administrative
        notifications.
        <br></br>•To allow you to participate in interactive features of our
        Service when you choose to do so.
        <br></br>•To verify your identity and eligibility to use the Services.
        <br></br>•To improve the administration of our Service and your
        experience.
        <br></br>•To provide customer support.
        <br></br>•To gather analysis or valuable information so that we can
        improve our Service.
        <br></br>•To monitor the usage of our Service.
        <br></br>•To monitor the frequency with which you use our Service.
        <br></br>•To investigate, detect, prevent and address fraud, abuse,
        technical issues, violations of our terms, policies, and agreements, and
        other harmful or unlawful activities.
        <br></br>•To comply with applicable laws, cooperate with investigations
        by law enforcement or other authorities of suspected violations of law,
        and/or to pursue or defend against legal threats and/or claims.
        <br></br>•To provide you with news, special offers and general
        information about other goods, services and events which we offer that
        are similar to those that you have already purchased or enquired about
        unless you have opted not to receive such information. For reasons that
        we may describe to you at the time of collection. We may create
        anonymous or aggregated information from personal information so that it
        is no longer personal information. We use this anonymous information to
        analyse use of our Services and improve our Service and other offerings.
        We reserve the right to use anonymous information for any legal purpose
        and to disclose anonymous information to third parties without
        restriction, except where it may be prohibited by applicable law.
      </p>
      <p className="termsUpper mt-3">
        <b>Disclosure of Information</b>
      </p>
      <p>
        Certain of your activity is visible to all users of our Services and to
        the public, including your profile name and address, avatar, your
        collection information, including NFTs collected and amounts spent, and
        the artists you have backed. By virtue of the public nature of the
        blockchain, the holdings and transactions associated with your wallet
        address will be publicly available and accessible to third parties. We
        may also share information in the following circumstances:
      </p>
      <p className="termsUpper mt-3">
        <b>Service Providers or Processors</b>
      </p>
      <p>
        We may disclose information to third-party service providers or
        contractors (processors) who use this information to perform services
        for us, such as hosting providers, auditors, advisors, consultants,
        customer service and/or support providers and other similar service
        providers.
      </p>
      <p className="termsUpper mt-3">
        <b>Advertising and Marketing Partners</b>
      </p>
      <p>
        We may share information with third parties that provide advertising,
        campaign measurement, promotions, online and/or mobile analytics, and
        related services. These third parties may receive or access browsing
        and/or other data about your use of the Services, in order to measure
        our ad campaigns, and/or to better understand how individuals interact
        with our Services.
      </p>
      <p className="termsUpper mt-3">
        <b></b>
      </p>
      <p></p>
      <p className="termsUpper mt-3">
        <b>Law Enforcement</b>
      </p>
      <p>
        Under certain circumstances, we may be required to disclose your
        information if required to do so by law or in response to valid requests
        by public authorities (e.g. a court or a government agency).
      </p>
      <p className="termsUpper mt-3">
        <b>Legal Requirements</b>
      </p>
      <p>
        We may disclose your information to law enforcement, government
        officials, or other third parties when we believe that disclosure is
        necessary to comply with a legal obligation (such as a court order,
        warrant, or subpoena), to prevent or investigate fraud, abuse, possible
        wrongdoing in connection the Service, prevent physical or financial
        loss, or to protect against legal liability.
      </p>
      <p className="termsUpper mt-3">
        <b>Business Transfers</b>
      </p>
      <p>
        We may share some or all of your information in preparation for, during
        negotiation of, or in the process of any merger, financing, acquisition,
        or dissolution transaction or proceeding involving sale, transfer,
        divestiture, or disclosure of all or a portion of our business or
        assets. We might also transfer or share information in the event of an
        insolvency, bankruptcy, or receivership.
      </p>
      <p className="termsUpper mt-3">
        <b>Protect our Rights and our Users</b>
      </p>
      <p>
        We may disclose Personal information where we believe it necessary to
        respond to claims asserted against us, to enforce or administer our
        agreements, terms, and policies, for fraud prevention, risk assessment,
        investigation and/or to protect our rights, property, or safety and that
        of our affiliates, partners, clients, customers, users and/or others.
      </p>
      <p className="termsUpper mt-3">
        <b>Other Disclosures</b>
      </p>
      <p>
        We may disclose information to other parties and for other purposes
        based on (a) your consent, (b) at your direction, (c) as described to
        you at the time the information is collected.
      </p>
      <p className="text-xl termsUpper mt-3">
        <b>Cookies and Analytics</b>
      </p>
      <p>
        We use cookies, pixels, tags, and other technologies, which may be
        provided by third parties, on our Services to enable certain
        functionality and for security and fraud detection and prevention, as
        well as to collect usage information about our Website and the emails
        that we send and to personalize content and provide more relevant ads
        and information. We may combine the information we collect via these
        technologies with other information, including Personal information.
        Cookies. Cookies are alphanumeric identifiers that are transferred to
        your computer through your web browser for record-keeping purposes. Some
        cookies enable you to log-in to our Services or save certain settings
        and preferences, while others allow us to track usage and activities on
        our Services, personalize content, or deliver more relevant ads. Most
        web browsers automatically accept cookies, but if you prefer, you can
        edit your browser options to block them in the future. The "Help" tab on
        the toolbar on most browsers will tell you how to prevent your computer
        from accepting new cookies, how to have the browser notify you when you
        receive a new cookie, or how to disable cookies altogether. If you block
        cookies, however, certain features on our Website may not be available
        or function properly.
        <br></br>Third parties may use cookies and other similar technologies to
        collect or receive information from our Site and elsewhere on the
        Internet and use that information to provide you with targeted ads. If
        you would like to opt-out of such advertising practices on the
        particular device on which you are accessing this Privacy Policy, please
        see the “Your Choices” section below. Note that opting-out does not mean
        you will no longer receive online advertising. It does mean that the
        company or companies from which you opted-out will no longer deliver ads
        tailored to your preferences and usage patterns. Opt outs are also
        device and browser specific.
        <br></br>Pixel tags and embedded script (aka clear GIFs and web
        beacons).
        <br></br>Pixel tags are tiny graphics with a unique identifier, similar
        in function to cookies. In contrast to cookies, which are stored on your
        computer’s hard drive, pixel tags are embedded invisibly on web pages.
        We may use these, in connection with our Website to, among other things,
        track the activities of the users of our Services, improve ads,
        personalize and manage content, and gather usage information about our
        Website. We may also use these in HTML emails to help us track email
        response rates, identify when our emails are viewed, and track whether
        our emails are forwarded.
        <br></br>Third-Party Analytics Tools. Our Website uses automated devices
        and applications operated by third parties, such as Google Analytics,
        which uses cookies and similar technologies to collect and analyze
        information about use of the Website and report on activities and
        trends. This service may also collect information regarding the use of
        other websites, apps and online resources. You can learn about Google's
        practices by going to www.google.com/policies/privacy/partners/, and you
        can opt out of them by downloading the Google Analytics opt-out browser
        add-on, available at https://tools.google.com/dlpage/gaoptout
      </p>
      <p className="termsUpper mt-3">
        <b>Security of Data</b>
      </p>
      <p>
        the Internet or method of electronic storage is 100% secure. While we
        strive to use commercially acceptable means to protect your Personal
        information, we cannot guarantee its absolute security.
      </p>
      <p className="termsUpper mt-3">
        <b>Links to Other Sites and Platforms</b>
      </p>
      <p>
        When you use our Service, you have the option to link to a third-party
        wallet which allows you to engage in transactions on public blockchains.
        Your interactions with any third-party wallet provider are governed by
        the applicable terms and privacy policy of that third party. You may
        also engage in transactions to purchase NFTs on third party sites, your
        interactions on those third party NFT marketplaces are governed by the
        marketplace’s terms and privacy policies. Our Service may contain links
        to other websites, plug-ins and applications that are not operated by
        us. If you click a third party link, you will be directed to that third
        party's site, which may allow third parties to collect or share data
        about you. We strongly advise you to review the privacy policy of every
        site you visit. We have no control over and assume no responsibility for
        the content, privacy policies or practices of any third party sites or
        services.
      </p>
      <p className="termsUpper mt-3">
        <b>Children's Privacy</b>
      </p>
      <p>
        Our services are not offered to children and we do not knowingly collect
        personally identifiable information from anyone under the age of 18 (or
        majority in the jurisdiction they are accessing the services from). If
        you are a parent or guardian and you are aware that your child has
        provided us with Personal information, please contact us. If we become
        aware that we have collected Personal information from children without
        verifiable parental consent, we will take steps to remove that
        information from our servers.
      </p>
      <p className="termsUpper mt-3">
        <b>Do Not Track</b>
      </p>
      <p>
        We do not currently recognize automated browser signals regarding
        tracking mechanisms, which may include “Do Not Track” (DNT) signals sent
        by web browsers, mobile devices, or other mechanisms. Third parties may
        be able to collect information, including Personal information, about
        your online activities over time and across different websites or online
        services when you use the Services. You may opt out of online behavioral
        ads at http://www.aboutads.info/choices/. You also may limit certain
        tracking by disabling cookies in your web browser.
      </p>
      <p className="termsUpper mt-3">
        <b>Users Outside of the United States.</b>
      </p>
      <p>
        If you access the Service from outside of the United States, by visiting
        the Service and providing us with data, you acknowledge and agree that
        your personal information may be processed for the purposes identified
        in the Privacy Policy. In addition, your personal information may be
        processed in the country in which it was collected and in other
        countries, including the United States, where laws regarding processing
        of personal information may be less stringent than the laws in your
        country. By providing your personal information, you consent to such
        transfer.
      </p>
      <p className="termsUpper mt-3">
        <b>Jurisdiction Specific Notices</b>
      </p>
      <p>
        If you are a resident of specific states you have additional rights
        described below:
        <br></br>California Residents Where applicable, California Civil Code
        Section 1798.83 allows California residents to request certain
        information regarding our disclosure of Personal information to third
        parties for their direct marketing purposes. To make such a request
        please contact us using the information provided in the Contact Us
        section below.
        <br></br>Nevada Residents If you are a resident of Nevada, you have the
        right to opt-out of the sale of certain Personal information to third
        parties who intend to license or sell that Personal information. You can
        exercise this right by contacting us at hello@wavwrld.com with the
        subject line “Nevada Do Not Sell Request” and providing us with your
        name and the email address associated with your account. Please note
        that we do not currently sell your Personal information as sales are
        defined in Nevada Revised Statutes Chapter 603A. If you have any
        questions, please contact us as set forth below.
      </p>
      <p className="termsUpper mt-3">
        <b>Changes to This Privacy Policy</b>
      </p>
      <p>
        We may update our Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page. Please
        check the “effective date” at the top of this Privacy Policy If required
        by applicable law, we will let you know via email and/or a prominent
        notice on our Service, prior to any significant changes becoming
        effective and update the "effective date" at the top of this Privacy
        Policy. You are advised to review this Privacy Policy periodically for
        any changes. Changes to this Privacy Policy are effective when they are
        posted on this page.
      </p>
      <p className="text-xl termsUpper mt-3">
        <b>Contacting us</b>
      </p>
      <p>
        If you have any questions about this Policy, please contact us using our
        email address: <b>hello@wavwrld.com</b>
      </p>
    </div>
  );
};
